import { useAuth } from "../../components/context/Auth";
import styles from "./Receipts.module.css";
import {
  DispatchDownloadIcon,
  DispatchReloadIcon,
  ManagerDevices3Dots,
} from "../../components/icons/Icon";
import Button from "../../components/updatedComponents/Dealers/Button";
import InputTypedate from "../../components/updatedComponents/FormComponents/InputTypedate";
import SlidingFilter2 from "../../components/updatedComponents/Dealers/SlidingFilter2";
import { useCallback, useEffect, useRef, useState } from "react";
import DealerStatusCard from "../../components/updatedComponents/Dealers/DealerStatusCard";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import fetchData from "../../APIsControll/apiControll";
import OptionsMenu from "../../components/updatedComponents/Receipts/OptionsMenu";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import AddReceiptModal from "../../components/updatedComponents/OrderManager/AddReceiptModal";
import { handleFileData } from "../../APIsControll/apiControl2";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import CancelReceiptModal from "../../components/updatedComponents/Receipts/CancelReceiptModal";
import Info from "../../components/updatedComponents/Receipts/Info";
import RefundReceipt from "../../components/updatedComponents/Receipts/RefundReceipt";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import { TemplateNotFound } from "../../components/icons/Icon2";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import { useNavigate } from "react-router-dom";
import { socket, SocketConnected } from "../../Socket/socket";
import Warning from "../../components/updatedComponents/Receipts/Warning";
import OrderHistory from "../../components/updatedComponents/Receipts/OrderHistory";
import InputRedio from "../../components/updatedComponents/FormComponents/InputRedio";
import Pagination2 from "../../components/updatedComponents/FormComponents/Pagination2";
import { printReceipt } from "../../components/updatedComponents/Printer/helper";
import { CryptoDecrypt } from "../../Utils/TextUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilter,
  setPagination,
} from "../../store/slices/receipt/ReceiptSlice";
import useTableHeight from "../../hooks/useTableHeight";
import { daysData, receiptHeader, yearData } from "../../constants/constants";
import {
  formatDateTime,
  getStatusColor,
  LastActionCell,
} from "../../Utils/Utils";
import useDebounce from "../../hooks/useDebounce";

const Receipts = () => {
  const { mode, managerId, designations, designation } = useAuth();

  const navigate = useNavigate();

  const { show } = useToast();

  const tableRef = useRef(null);

  const { filter, pagination } = useSelector((r) => r.receipt);
  const dispatch = useDispatch();

  const limit = useTableHeight(tableRef);

  const debouncedKeyword = useDebounce(filter.keyword, 700);

  const [loading, setLoading] = useState(false);
  const [loading2, setloading2] = useState(false);
  const [data, setData] = useState([]);
  const [managers, setManagers] = useState([]);
  const [receiptState, setReceiptState] = useState([]);
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [payAuth, setPayAuth] = useState({});
  const [IPs, setIPs] = useState();
  const [reFetch, setReFetch] = useState(false);

  const getAllReceipts = useCallback(async () => {
    if (
      filter.receiptDaysTab === "period" &&
      (filter.receiptStartDate === "" || filter.receiptEndDate === "")
    )
      return;

    const apiData = {
      managerId: managerId,
      keyword: debouncedKeyword,
      day: filter.receiptDaysTab === "period" ? "" : filter.receiptDaysTab,
      endDate: filter.receiptEndDate,
      startDate: filter.receiptStartDate,
      searchBy: filter.selectedRadio.value,
      paymentMethod: filter.shipingTab.value,
      sortByManagerId: filter.selectedManagerID,
      status: filter.status,
      accountNumber:
        filter.selectedAccount.value === null
          ? ""
          : filter.selectedAccount.value,
    };
    try {
      setLoading(true);
      const result = await fetchData(
        "receipt/receipts?page=" + pagination.page + "&limit=" + limit,
        apiData,
      );
      if (result.status === "success") {
        setData(result.data);
        setReceiptState(result.receipts);
        dispatch(setPagination({ pages: result.pages }));
        setAccounts(result.accounts);
        if (result.paymentManagers) {
          setManagers(result.paymentManagers);
        }
      }
      const accs = result.accounts.map((a) => ({
        label: a.bankName,
        value: a.accountNumber,
      }));

      setAccounts(accs);

      if (result.status === "failed") {
        setData([]);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [
    dispatch,
    debouncedKeyword,
    filter.receiptDaysTab,
    filter.receiptEndDate,
    filter.receiptStartDate,
    filter.selectedAccount.value,
    filter.selectedManagerID,
    filter.selectedRadio.value,
    filter.shipingTab.value,
    filter.status,
    limit,
    managerId,
    pagination.page,
  ]);

  useEffect(() => {
    if (limit === 1) return;
    getAllReceipts();
  }, [
    dispatch,
    debouncedKeyword,
    filter.receiptDaysTab,
    filter.receiptEndDate,
    filter.receiptStartDate,
    filter.selectedAccount.value,
    filter.selectedManagerID,
    filter.selectedRadio.value,
    filter.shipingTab.value,
    filter.status,
    limit,
    managerId,
    pagination.page,
    getAllReceipts,
    reFetch,
  ]);

  useEffect(() => {
    if (filter.status === "All") {
      if (
        !designations ||
        (!designations.includes("superadmin") &&
          !designations.includes("paymentmanager"))
      ) {
        return;
      }

      if (!managerId || !designation) return;

      let storedWarehouse = null;
      try {
        storedWarehouse = JSON.parse(localStorage.getItem("warehouse"));
      } catch (e) {
        console.warn("Failed to parse warehouse from localStorage:", e);
      }

      SocketConnected({
        socketUserId: `${managerId}`,
        role: designation,
        warehouseNames: storedWarehouse,
      });

      const handleReceipts = (payload) => {
        // console.log("[socket] receipts payload received:", payload);

        const receiptsObj =
          payload?.allreceipts ||
          payload?.allrecipts ||
          payload?.allReceipts ||
          payload?.receipts ||
          (payload?.data && { data: payload.data, receipts: payload.receipts });

        if (!receiptsObj) {
          console.warn(
            "[socket] could not find receipts payload under expected keys",
          );
          return;
        }

        const incomingArray = receiptsObj.data || receiptsObj.receipts || [];
        if (!Array.isArray(incomingArray) || incomingArray.length === 0) {
          // console.log(
          //   "[socket] receipts data is empty or not an array:",
          //   incomingArray
          // );
          return;
        }

        setData((prev = []) => {
          const map = new Map(prev.map((r) => [String(r.receiptId), r]));
          incomingArray.forEach((inc) => {
            const key = String(
              inc.receiptId ?? inc.id ?? inc.orderId ?? Symbol(),
            );
            if (!key) return;
            const existing = map.get(key);
            if (existing) {
              map.set(key, { ...existing, ...inc });
            } else {
              map.set(key, inc);
            }
          });
          const incomingKeys = new Set(
            incomingArray.map((i) => String(i.receiptId ?? i.id ?? i.orderId)),
          );
          const merged = [
            ...incomingArray.map((i) =>
              map.get(String(i.receiptId ?? i.id ?? i.orderId)),
            ),
            ...Array.from(map.values()).filter(
              (v) =>
                !incomingKeys.has(String(v.receiptId ?? v.id ?? v.orderId)),
            ),
          ];
          return merged;
        });

        // const first = incomingArray[0];
        // if (first && first.status === "Pending") {
        // }
      };

      try {
        socket.off("allreceipts", handleReceipts);
        socket.off("allrecipts", handleReceipts);
      } catch (e) {}

      socket.on("allreceipts", handleReceipts);
      socket.on("allrecipts", handleReceipts);

      const anyHandler = (eventName, payload) => {
        // console.debug("[socket any] event:", eventName, "payload:", payload);
      };
      if (typeof socket.onAny === "function") {
        socket.onAny(anyHandler);
      }

      return () => {
        socket.off("allreceipts", handleReceipts);
        socket.off("allrecipts", handleReceipts);
        if (typeof socket.offAny === "function") {
          try {
            socket.offAny(anyHandler);
          } catch (_) {}
        }
      };
    }
  }, [designation, designations, filter.status, managerId]);

  useEffect(() => {
    const storedIPs = localStorage.getItem("printerIPs");
    if (storedIPs) {
      setIPs(JSON.parse(storedIPs));
    }
  }, []);

  useEffect(() => {
    const encrypted = localStorage.getItem("managerAuth");

    if (encrypted) {
      try {
        const decrypted = JSON.parse(CryptoDecrypt(encrypted));
        // console.log("decrypted", decrypted);
        setPayAuth(decrypted);
      } catch (error) {
        console.error("Failed to decrypt managerAuth:", error);
      }
    }
  }, []);
  // console.log("payAuth.onlyCollectCash ", payAuth.onlyCollectCash);
  const getReceiptData = async (receiptId, orderId, _case_, reason, r) => {
    setloading2(true);
    const apiData = {
      managerId: managerId,
      receiptId: receiptId,
      orderId: orderId,
    };
    try {
      const result = await fetchData("receipt/receipt", apiData);
      if (result.status === "success") {
        setloading2(false);
        if (_case_ === "click") {
          handleOpenModal(
            <AddReceiptModal
              mode={mode}
              handleCloseModal={handleCloseModal}
              accounts={result.accounts}
              receiptData={result.data}
              totalAmount={result.data.paymentAmount}
              updateReceiptData={(updatedData, print) =>
                verifyReceipt(updatedData, print)
              }
              type="edit"
              flag="verify"
              revertCase={() => openRevertBackModal(result.data)}
              showCollect={payAuth.onlyCollectCash}
            />,
          );
        }
        if (_case_ === "update") {
          handleOpenModal(
            <AddReceiptModal
              mode={mode}
              handleCloseModal={handleCloseModal}
              accounts={result.accounts}
              receiptData={result.data}
              updateReceiptData={(updatedData, print) =>
                verifyReceipt(updatedData, print)
              }
              type="update"
              showCollect={payAuth.onlyCollectCash}
            />,
          );
        }
        if (_case_ === "refund") {
          handleOpenModal(
            <RefundReceipt
              mode={mode}
              handleCloseModal={handleCloseModal}
              accounts={result.accounts}
              amount={result.data.paymentAmount}
              receiptId={result.data.receiptId}
              orderId={result.data.orderId}
              reason={reason ? reason : ""}
              receiptData={result.data}
              updateReceiptData={(updatedData) => refundReceipt(updatedData)}
            />,
          );
        }
        if (_case_ === "cancel") {
          handleOpenModal(
            <CancelReceiptModal
              managerId={managerId}
              mode={mode}
              handleCloseModal={handleCloseModal}
              receiptData={result.data}
              receiptId={result.data.receiptId}
              orderId={result.data.orderId}
              revertCase={"false"}
            />,
          );
        }
      }
    } catch (error) {
      setloading2(false);
    }
  };

  const verifyReceipt = async (receiptData, print) => {
    if (print && !IPs?.receipt) {
      show("Printer's IP for receipts is missing!", "error");
      return;
    }

    const formData = new FormData();
    formData.append("managerId", managerId);
    formData.append("receiptId", receiptData.receiptId);
    formData.append("orderId", receiptData.orderId);
    formData.append(
      "paymentMethod",
      receiptData.paymentMethod ? receiptData.paymentMethod : "",
    );
    formData.append(
      "paymentType",
      receiptData.paymentType ? receiptData.paymentType : "",
    );
    formData.append(
      "accountNumber",
      receiptData.accountNumber ? receiptData.accountNumber : "",
    );
    formData.append(
      "transactionScreenshot",
      receiptData.transactionScreenshot
        ? receiptData.transactionScreenshot
        : "",
    );
    formData.append(
      "warehousename",
      receiptData.warehousename ? receiptData.warehousename : "",
    );

    if (
      (receiptData.paymentMethod !== "Cash" ||
        !(
          receiptData.paymentAmount === "POD" &&
          receiptData.paymentType === "Cash"
        )) &&
      receiptData.transactionId
    ) {
      formData.append("transactionId", receiptData.transactionId);
    }

    formData.append(
      "paymentAmount",
      receiptData.paymentAmount ? receiptData.paymentAmount : "",
    );

    try {
      const result = await handleFileData("receipt/verifyreceipt", formData);

      if (result.status === "success") {
        handleCloseModal();
        show(result.msg, "success");
      }

      if (result?.status === "warning") {
        setModalContent(
          <Warning
            message={result?.msg}
            items={result?.items}
            orderdItems={result?.orderdItems}
            mode={mode}
            handleCloseModal={handleCloseModal}
          />,
        );
      }

      if (print) {
        printReceipt(IPs.receipt, "80", result.data);
      }

      if (result.status === "warn") {
        show(result.msg, "warning");
      }

      if (result.status === "failed") {
        show(result.msg, "error");
      }
    } catch (error) {
      console.error("Error verifying receipt:", error);
    }
  };

  const refundReceipt = async (receiptData) => {
    const formData = new FormData();
    formData.append("managerId", managerId);
    formData.append("receiptId", receiptData.receiptId);
    formData.append("orderId", receiptData.orderId);
    formData.append(
      "refundMethod",
      receiptData.refundMethod ? receiptData.refundMethod : "",
    );
    formData.append(
      "refundByAccount",
      receiptData.refundByAccount ? receiptData.refundByAccount : "",
    );
    formData.append(
      "transactionScreenshot",
      receiptData.refundtransactionSS ? receiptData.refundtransactionSS : "",
    );
    formData.append(
      "refundTransactionId",
      receiptData.refundTransactionId ? receiptData.refundTransactionId : "",
    );
    formData.append(
      "refundAmt",
      receiptData.refundAmt ? receiptData.refundAmt : "",
    );
    formData.append(
      "reason",
      receiptData.refundreason ? receiptData.refundreason : "",
    );
    try {
      const result = await handleFileData("receipt/refundreceipt", formData);
      if (result.status === "success") {
        handleCloseModal();
        show(result.msg, "success");
      }
      if (result.status === "warn" || result.status === "warning") {
        show(result.msg, "warning");
      }
      if (result.status === "failed") {
        show(result.msg, "error");
      }
    } catch (error) {}
  };

  const openRevertBackModal = (receiptData) => {
    handleOpenModal(
      <CancelReceiptModal
        managerId={managerId}
        mode={mode}
        handleCloseModal={handleCloseModal}
        receiptData={receiptData}
        receiptId={receiptData.receiptId}
        orderId={receiptData.orderId}
        revertCase={"true"}
      />,
    );
  };

  const openUpdateModal = async (r) => {
    await getReceiptData(r.receiptId, r.orderId, "update", "", r);
  };

  const openRefundModal = async (r) => {
    await getReceiptData(r.receiptId, r.orderId, "refund", "", r);
  };

  const openCancelModal = async (r) => {
    await getReceiptData(r.receiptId, r.orderId, "cancel", "", r);
  };

  const handleRowClick = async (r) => {
    if (r.status === "Pending For Refund" || r.status === "Refund") {
      await getReceiptData(r.receiptId, r.orderId, "refund", r.reason, r);
    } else {
      await getReceiptData(r.receiptId, r.orderId, "click", r.reason, r);
    }
  };

  const openInfoModal = (status) => {
    handleOpenModal(
      <Info mode={mode} handleCloseModal={handleCloseModal} status={status} />,
    );
  };

  const handleOpenModal = (content) => {
    setIsModalOpen(true);
    setModalContent(content);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const daysTabChange = (label) => {
    const selectedFilter = daysData.find((item) => item.label === label);
    const newDayTab = selectedFilter?.value || "today";

    dispatch(setFilter({ receiptDaysTab: newDayTab }));
    dispatch(setPagination({ page: 1 }));

    if (newDayTab !== "period") {
      dispatch(setPagination({ pages: [] }));
      dispatch(setFilter({ receiptStartDate: "" }));
      dispatch(setFilter({ receiptEndDate: "" }));
    }
  };

  const shippingTabChange = (label) => {
    const selectedFilter = methodData.find((item) => item.label === label);
    dispatch(setFilter({ shipingTab: selectedFilter }));
  };

  const handleManagerSelection = (option) => {
    dispatch(setFilter({ selectedManagerID: option.value }));
  };

  const handleManagerRejection = () => {
    dispatch(setFilter({ selectedManagerID: null }));
  };

  const resetAllStates = () => {
    dispatch(setPagination({ page: 1 }));
    dispatch(setPagination({ pages: 1 }));
    dispatch(setFilter({ receiptDaysTab: "today" }));
    dispatch(setFilter({ keyword: "" }));
    dispatch(setFilter({ receiptStartDate: "" }));
    dispatch(setFilter({ receiptEndDate: "" }));
    dispatch(setFilter({ status: "All" }));
    dispatch(setFilter({ shipingTab: { label: "All", value: "" } }));
    dispatch(setFilter({ selectedManagerID: null }));

    setLoading(false);
    setloading2(false);

    setActiveMenuIndex(null);
    setModalContent(null);
    setIsModalOpen(false);
    setReFetch((prev) => !prev);
  };

  const receiptStatus = [
    {
      status: "All",
      label: "All",
      count: receiptState[0]?.count || 0,
      allCount: receiptState[0]?.prevCount || 0,
      amount: receiptState[0]?.amount || 0,
    },
    {
      status: "Pending",
      label: "Pending",
      count: receiptState[1]?.count || 0,
      allCount: receiptState[1]?.prevCount || 0,
      amount: receiptState[1]?.amount || 0,
    },
    {
      status: "POD Pending",
      label: "POD Pending",
      count: receiptState[2]?.count || 0,
      allCount: receiptState[2]?.prevCount || 0,
      amount: receiptState[2]?.amount || 0,
    },
    {
      status: "Pending For Verification",
      label: "Pending For Verification",
      count: receiptState[3]?.count || 0,
      allCount: receiptState[3]?.prevCount || 0,
      amount: receiptState[3]?.amount || 0,
    },
    {
      status: "Pending For Refund",
      label: "Pending For Refund",
      count: receiptState[4]?.count || 0,
      allCount: receiptState[4]?.prevCount || 0,
      amount: receiptState[4]?.amount || 0,
    },
    {
      status: "Refund",
      label: "Refund",
      count: receiptState[5]?.count || 0,
      allCount: receiptState[5]?.prevCount || 0,
      amount: receiptState[5]?.amount || 0,
    },
    {
      status: "Cancelled",
      label: "Cancelled",
      count: receiptState[6]?.count || 0,
      allCount: receiptState[6]?.prevCount || 0,
      amount: receiptState[6]?.amount || 0,
    },
    {
      status: "Cash Pending at Partner",
      label: "Pending at Partner",
      count: receiptState[7]?.count || 0,
      allCount: receiptState[7]?.prevCount || 0,
      amount: receiptState[7]?.amount || 0,
    },
    {
      status: "Cash Pending at Collector",
      label: "Pending at Collector",
      count: receiptState[8]?.count || 0,
      allCount: receiptState[8]?.prevCount || 0,
      amount: receiptState[8]?.amount || 0,
    },
    {
      status: "Received",
      label: "Received",
      count: receiptState[9]?.count || 0,
      allCount: receiptState[9]?.prevCount || 0,
      amount: receiptState[9]?.amount || 0,
    },
  ];

  const methodData = [
    { value: "All", label: "All" },
    { value: "Cash", label: "Cash" },
    { value: "POD", label: "POD" },
    ...(designation === "superadmin"
      ? [
          { value: "Photo", label: "Photo" },
          { value: "Online", label: "Online" },
        ]
      : []),
  ];

  const canViewOrder =
    designations.includes("superadmin") ||
    designations.includes("ordermanager") ||
    designations.includes("inventorymanager") ||
    designations.includes("paymentmanager");

  const routeName = "Receipts";

  return (
    <>
      <div
        className={styles.receipts}
        style={
          mode ? { backgroundColor: "#2C2E33", borderColor: "#2C2E33" } : {}
        }
      >
        <ModalWrapper
          isOpen={isModalOpen || loading2}
          onClose={handleCloseModal}
          noBtn
        >
          {loading2 ? (
            <p style={mode ? { color: "#FFFFFF" } : {}}>Loading...</p>
          ) : (
            modalContent
          )}
        </ModalWrapper>
        <div className={styles.receipts_top}>
          <div className={styles.receipts_top_left}>
            <TopTabBar text={routeName} />
          </div>
          <div className={styles.receipts_right}>
            <div>
              <SlidingFilter2
                itemList={daysData.map((item) => item.label)}
                setFilter={daysTabChange}
                selectedItem={
                  daysData.find((item) => item.value === filter.receiptDaysTab)
                    ?.label
                }
              />
            </div>
            {filter.receiptDaysTab === "period" && (
              <>
                <div>
                  <InputTypedate
                    text={"From"}
                    value={filter.receiptStartDate}
                    max={filter.receiptEndDate}
                    onChange={(e) => {
                      dispatch(setFilter({ receiptStartDate: e.target.value }));
                      if (filter.receiptDaysTab !== "period") {
                        dispatch(setFilter({ receiptDaysTab: "" }));
                      }
                      dispatch(setFilter({ status: "" }));
                    }}
                  />
                </div>
                {filter.receiptStartDate !== "" && (
                  <div>
                    <InputTypedate
                      text={"To"}
                      value={filter.receiptEndDate}
                      min={filter.receiptStartDate}
                      onChange={(e) => {
                        dispatch(setFilter({ receiptEndDate: e.target.value }));
                        if (filter.receiptDaysTab !== "period") {
                          dispatch(setFilter({ receiptDaysTab: "" }));
                        }
                        dispatch(setFilter({ status: "" }));
                      }}
                    />
                  </div>
                )}
              </>
            )}

            {designation.includes("superadmin") && (
              <DropDown
                label={"F.Y."}
                listLabel={"2025-2026"}
                options={yearData}
                onSelect={(option) =>
                  dispatch(setFilter({ selectedYear: option.label }))
                }
                onReject={() => dispatch(setFilter({ selectedYear: null }))}
              />
            )}

            <div>
              <Button
                buttonIcon={<DispatchReloadIcon />}
                buttonBgColor={"#000000"}
                buttonTextColor={"#ffffff"}
                buttonBorder={"none"}
                buttonClick={resetAllStates}
              />
            </div>
            <div>
              <Button
                buttonIcon={<DispatchDownloadIcon />}
                buttonBgColor={"#000000"}
                buttonTextColor={"#ffffff"}
                buttonBorder={"none"}
                buttonClick={() => console.log(filter.selectedYear)}
              />
            </div>
            <div>
              <Button
                buttonText={"Create Receipt"}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#ffffff"}
                buttonBorder={"none"}
                buttonClick={() => {
                  show("Feature in development!", "info");
                  // handleOpenModal(
                  //   <OrderHistory
                  //     mode={mode}
                  //     managerId={managerId}
                  //     close={() => setIsModalOpen(false)}
                  //   />,
                  // );
                }}
              />
            </div>
            {(designation.includes("superadmin") ||
              payAuth.settelCashCollection) && (
              <div>
                <Button
                  buttonText={"Settle"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonBorder={"none"}
                  buttonClick={() => navigate("/recipts/bulkreception")}
                />
              </div>
            )}
            <Pagination2
              mode={mode}
              currentPage={pagination.page}
              setCurrentPage={(newPage) =>
                dispatch(setPagination({ page: newPage }))
              }
              totalPages={pagination.pages}
            />
          </div>
        </div>

        <div className={styles.receipts_filters_con}>
          <div
            className={styles.receipts_filters}
            style={
              mode ? { borderColor: "#232529", backgroundColor: "#232529" } : {}
            }
          >
            <>
              {receiptStatus?.map((s) => (
                <div
                  key={s.status}
                  className={`${styles.receipts_filter} ${
                    mode ? styles.receipts_filter_dark : ""
                  } ${
                    s.status === filter.status
                      ? mode
                        ? styles.receipts_filter_active_dark
                        : styles.receipts_filter_active
                      : ""
                  }`}
                  onClick={async () => {
                    if (s.status === filter.status) {
                      await getAllReceipts();
                    } else {
                      dispatch(setFilter({ status: s.status }));
                      dispatch(setPagination({ page: 1 }));
                    }
                  }}
                >
                  <DealerStatusCard
                    statusText={s.label}
                    statusItemCount={s.count}
                    statusAllCount={s.allCount}
                    type={"receipt"}
                    amount={s.amount}
                  />
                </div>
              ))}
            </>
          </div>
        </div>

        <div className={styles.receipts_bottom}>
          <div className={styles.receipts_bottom_header}>
            <div className={styles.radio_optns}>
              <SearchBar
                padding={"6px"}
                fontSize={"12px"}
                fontWeight={"400"}
                borderRadius={"5px"}
                placeholder={filter.selectedRadio.label}
                value={filter.keyword}
                onChange={(e) => {
                  dispatch(setFilter({ keyword: e.target.value }));
                  dispatch(setPagination({ page: 1 }));
                }}
              />
              <InputRedio
                lableText="Order ID"
                name="orderId"
                id="orderId"
                value="orderId"
                checked={filter.selectedRadio.value === "orderId"}
                onChange={() =>
                  dispatch(
                    setFilter({
                      selectedRadio: {
                        label: "Order ID",
                        value: "orderId",
                      },
                    }),
                  )
                }
              />
              <InputRedio
                lableText="Receipt ID"
                name="receipt"
                id="receipt"
                value="receipt"
                checked={filter.selectedRadio.value === "receipt"}
                onChange={() =>
                  dispatch(
                    setFilter({
                      selectedRadio: {
                        label: "Receipt ID",
                        value: "receipt",
                      },
                    }),
                  )
                }
              />
              <InputRedio
                lableText="UTR/RRN"
                name="transactionId"
                id="transactionId"
                value="transactionId"
                checked={filter.selectedRadio.value === "transactionId"}
                onChange={() =>
                  dispatch(
                    setFilter({
                      selectedRadio: {
                        label: "UTR/RRN",
                        value: "transactionId",
                      },
                    }),
                  )
                }
              />
            </div>

            <div className={styles.receipts_bottom_filters}>
              <div>
                <SlidingFilter2
                  itemList={methodData.map((item) => item.label)}
                  setFilter={shippingTabChange}
                  selectedItem={filter.shipingTab.label}
                />
              </div>
              {designations.includes("superadmin") && (
                <>
                  <DropDown
                    label={"Account"}
                    listLabel={"All"}
                    options={accounts}
                    onSelect={(v) =>
                      dispatch(setFilter({ selectedAccount: v }))
                    }
                    onReject={() =>
                      dispatch(setFilter({ selectedAccount: {} }))
                    }
                  />
                  <DropDown
                    label={"Manager"}
                    listLabel={"All"}
                    options={
                      managers &&
                      managers.map((m) => ({
                        label: m.name,
                        value: m.managerId,
                      }))
                    }
                    onSelect={handleManagerSelection}
                    onReject={handleManagerRejection}
                  />
                </>
              )}
            </div>
          </div>

          <ul className={styles.receipts_data} ref={tableRef}>
            <li
              className={`${styles.receipts_data_header} ${
                mode ? styles.receipts_data_header_dark : ""
              }`}
            >
              {receiptHeader.map((h, index) => (
                <div className={styles.entry} key={`${h}-${index}`} title={h}>
                  {h}
                </div>
              ))}
            </li>
            <div className={`${styles.receipts_data_list} ${styles.rdl}`}>
              {loading ? (
                <div>
                  <Skeleton
                    lines={15}
                    thickness={5}
                    additionalStyles={{ marginBottom: "0px", marginTop: "0px" }}
                  />
                </div>
              ) : (
                <>
                  {!loading && data.length === 0 ? (
                    <div className={styles.no_data}>
                      <NoDataFound
                        icon={<TemplateNotFound />}
                        textTitle={`No Data Found`}
                      />
                    </div>
                  ) : (
                    <>
                      {data.map((r, index) => (
                        <div key={index}>
                          <li
                            className={`${styles.receipts_data_row} ${
                              mode ? styles.receipts_data_row_dark : ""
                            }
                              
                             ${
                               r.orderType === "Direct Collect"
                                 ? styles.direct_collect
                                 : r.orderType === "Master Order"
                                   ? styles.master_order
                                   : ""
                             }
                            
                            `}
                            onClick={() => {
                              handleRowClick(r);
                            }}
                          >
                            <div
                              className={styles.entry}
                              title={
                                r?.receiptId +
                                ", " +
                                r?.receiptTime +
                                ", " +
                                formatDateTime(r?.receiptDate)
                              }
                            >
                              {r.receiptId}, {r.receiptTime},{" "}
                              {formatDateTime(r.receiptDate)}
                            </div>
                            <div className={styles.entry} title={r.orderId}>
                              <span
                                style={{
                                  textDecoration: canViewOrder && "underline",
                                }}
                                onClick={(e) => {
                                  if (canViewOrder) {
                                    e.stopPropagation();
                                    navigate(
                                      "/orders/order/saleorder?orderId=" +
                                        r.orderId,
                                    );
                                  }
                                }}
                              >
                                {r.orderId}
                              </span>
                            </div>
                            <div
                              className={styles.entry}
                              title={
                                r.storeName + ", " + r.city + ", " + r.dealerId
                              }
                            >
                              {r.storeName}, {r.city}, {r.dealerId}
                            </div>
                            <div className={styles.entry} title={r.createdBy}>
                              {r.createdBy}{" "}
                            </div>
                            <div
                              className={styles.entry}
                              title={r.ordermanager}
                            >
                              {r.ordermanager}{" "}
                            </div>
                            <div
                              className={styles.entry}
                              title={r.dispatchStatus}
                              style={{
                                color: getStatusColor(
                                  r.dispatchStatus ? "Yes" : "No",
                                ),
                              }}
                            >
                              {r.dispatchStatus ? "Yes" : "No"}
                            </div>
                            <div
                              className={styles.entry}
                              title={r?.partnerNames?.join(", ")}
                            >
                              {r?.partnerNames?.join(", ")}
                            </div>
                            <div
                              className={styles.entry}
                              title={r.paymentAmount}
                            >
                              {r.paymentAmount}
                            </div>
                            <div
                              className={styles.entry}
                              title={r.paymentMethod}
                            >
                              {r.paymentMethod}
                            </div>
                            <div
                              className={styles.entry}
                              style={{ color: getStatusColor(r.status) }}
                              title={r.status}
                            >
                              {r.status === "Cash Pending at Partner"
                                ? "Partner Pending"
                                : r.status === "Cash Pending at Collector"
                                  ? "Collector Pending"
                                  : r.status}
                            </div>
                            <div className={styles.entry} title={r.verifyBy}>
                              {" "}
                              {r.verifyBy}{" "}
                            </div>
                            <div className={styles.entry} title={r.lastAction}>
                              <LastActionCell lastAction={r.lastAction} />,
                            </div>
                            <div
                              className={styles.options}
                              onClick={(e) => {
                                e.stopPropagation();
                                setActiveMenuIndex((prevIndex) =>
                                  prevIndex === index ? null : index,
                                );
                              }}
                            >
                              <ManagerDevices3Dots
                                color={mode ? "#ffffff" : "#1C274C"}
                              />
                            </div>

                            {activeMenuIndex === index && (
                              <OptionsMenu
                                mode={mode}
                                closeMenu={() => setActiveMenuIndex(null)}
                                index={index}
                                receiptData={r}
                                openInfoModal={openInfoModal}
                                openCancelReceiptModal={openCancelModal}
                                openUpdateModal={openUpdateModal}
                                openRefundModal={openRefundModal}
                                openReceiptModal={getReceiptData}
                              />
                            )}
                          </li>
                          {/* {r.reason !== "" && (
                            <div
                              style={mode ? { color: "#FFFFFF" } : {}}
                              className={styles.desc}
                            >
                              {r.reason}
                            </div>
                          )} */}
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}
            </div>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Receipts;
